import actions from "./actions";
import mutations from "./mutations";

export default {
  namespaced: true,
  state: {
    tableLoading: false,
    departments: [],
    branches: [],
    stationDepartments: [],
    totalEmployees: null,
    employees: [],
    currentPage: 1,
    perPage: 5,
    searchQuery: "",
    filterValue: null,
  },
  actions,
  mutations,
};
